import styled from '@emotion/styled';
import { Typography, Button, Divider } from '@mgmresorts/mgm-ui';

export const StyledVerificationText = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  }
`;

export const StyledDescriptionText = styled(Typography)`
  text-align: center;
  margin: ${({ theme }) => theme.semantic.SpaceComponentS}px 0 32px 0;
  width: 95%;
  color: ${({ theme }) => theme.semantic.FgContrast};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledEmailFieldLabel = styled(Typography)`
  text-align: left;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

// Common Container with 16px padding for middle section
export const StyledEnrollmentSection = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.semantic.BorderRadiusM}px;
`;

// Button Components
export const StyledEnrollmentButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

// Footer Components
export const StyledFooterLinks = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
  font-size: ${({ theme }) => theme.core.FontsizeS}px;
`;

export const StyledLinkButton = styled.button`
  text-decoration: underline;
`;

export const StyledSkipButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDivider = styled(Divider)`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  width: 100%;
`;
export const StyledDivContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  border-radius: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
